/**
 * volume模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const volume = {
  //卷列表分页
  pageVolume(params) {
    return $http.post(`${global.API_URL}/sme/volume/page`,params);
  },
  //卷删除
  deleteVolume(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/volume/delete`,param);
  },
  // 根据AccountId查询卷列表
  queryVolumesByAccountId(params) {
    return $http.post(`${global.API_URL}/sme/volume/queryVolumesByAccountId`,params);
  },
  // 磁盘详情
  queryVolumeByVolumeId(params) {
    return $http.post(`${global.API_URL}/sme/volume/queryVolumeByVolumeId`,params);
  },

}

export default volume;



// WEBPACK FOOTER //
// ./src/api/volume.js